import { parseJson } from '../../util/parse';

export let settings: Readonly<{
	cookieNames: Readonly<{
		homeTab: string;
	}>,
	strings: Readonly<{
		stopAllActiveOperations: string;
		pinsDoNotMatch: string;
		pinMustDiffer: string;
		pinMustConsistOfOnlyNumbers: string;
	}>
}>

export function parse(data: string) {
	settings = parseJson<typeof settings>(data);
}
